import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';

import { captureMagicLinkToken } from '../auth/utils/magic-link-token';

captureMagicLinkToken();

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

// Authentication credentials and their request bodies must never be captured by tracing or replay.
if (dsn && window.location.pathname !== '/login/email') {
  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    integrations: [
      // React Router v7 navigation tracing
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      // Session Replay (disabled by default below via sampling rates)
      Sentry.replayIntegration({
        blockAllMedia: true,
        maskAllText: true,
        maskAllInputs: true,
        networkCaptureBodies: false,
      }),
    ],
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1'),
    replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? '0'),
    replaysOnErrorSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? '1.0'),
    beforeSend(event) {
      // Keep local/dev noise out of Sentry unless explicitly enabled
      if (import.meta.env.DEV && !import.meta.env.VITE_SENTRY_ENABLE_IN_DEV) {
        return null;
      }
      return event;
    },
  });
} else if (!dsn) {
  if (import.meta.env.DEV) {
    console.info('[sentry] VITE_SENTRY_DSN not set – Sentry disabled');
  }
}

export {};
